import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppService} from '../app.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-body',
    templateUrl: './body.component.html',
    styleUrls: ['./body.component.css'],
    standalone: false
})
export class BodyComponent implements OnInit, OnDestroy {

  red = false;
  private redSubscription: Subscription;

  constructor(private appService: AppService) { }

  ngOnInit() {
    this.redSubscription = this.appService.redSubject.subscribe(
      (value: boolean) => {
        this.red = value;
      }
    );

    this.red = this.appService.getRed();
  }

  ngOnDestroy(): void {
    this.redSubscription.unsubscribe();
  }

}
